import React from "react";
import logo from "../white-logo.png";


const SplashPage = (props) => {

    return (
        <div className="splash">
            <div className="splash-container ">
                <div className="splash-box">
                    <img className="animate__animated animate__pulse animate__infinite	infinite img-fluid" src={logo} alt="" />
                </div>
                <div className="splash-info-box">
                    <p>{props.error}</p>
                </div>
            </div>
        </div>
    )
}

export default SplashPage;